import React from "react";

export const ParticipantContext = React.createContext();
